import React from 'react';
import { GitBookHider } from 'components/GitBookHider';

export default function(ComposedComponent, auth) {
    // eslint-disable-next-line react/prefer-stateless-function
    class Raw extends React.Component {
        // Otherwise render the original component
        render() {
            return (
                <>
                    <GitBookHider />
                    <ComposedComponent {...this.props} auth={auth} />
                </>
            );
        }
    }

    return Raw;
}
